var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2141(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.866,
    height: 50,
    viewBox: "0 0 60.866 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M-228.217,270.614v-.779c0-2.287,0-4.573,0-6.859a2.177,2.177,0,0,1,2.159-2.3,2.175,2.175,0,0,1,2.18,2.279q.009,6.384,0,12.768a2.161,2.161,0,0,1-1.408,2.183,2.107,2.107,0,0,1-2.408-.587c-2.493-2.5-4.995-4.994-7.475-7.508a1.424,1.424,0,0,0-1.125-.456q-9.135.022-18.269.009a5.957,5.957,0,0,1-6.261-6.263q0-7.912,0-15.824a5.943,5.943,0,0,1,6.152-6.165q12.327,0,24.654,0a5.947,5.947,0,0,1,6.14,6.108q.006,3.362,0,6.724a2.2,2.2,0,0,1-2.151,2.377,2.2,2.2,0,0,1-2.19-2.407c0-2.2,0-4.392,0-6.588a1.66,1.66,0,0,0-1.88-1.872q-12.225,0-24.45,0c-1.331,0-1.93.61-1.931,1.96q0,7.844,0,15.689a1.676,1.676,0,0,0,1.906,1.918q9.746,0,19.492-.009a2.745,2.745,0,0,1,2.115.867c1.372,1.413,2.774,2.8,4.166,4.19C-228.646,270.226-228.482,270.368-228.217,270.614Z",
    transform: "translate(284.738 -228.072)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M-432.457,178.9c1.6-1.586,3.154-3.1,4.672-4.651a2.8,2.8,0,0,1,2.173-.893c2.693.03,5.387.009,8.081.011a2.2,2.2,0,0,1,2.412,2.184,2.209,2.209,0,0,1-2.439,2.157c-2.309,0-4.617.012-6.926-.01a1.344,1.344,0,0,0-1.059.449q-3.677,3.718-7.382,7.408a2.164,2.164,0,0,1-2.563.678,2.255,2.255,0,0,1-1.366-2.285q.014-16.366.007-32.733a5.938,5.938,0,0,1,6.073-6.105q14.567-.008,29.133,0a5.944,5.944,0,0,1,6.088,6.092c0,.86.012,1.721,0,2.581a2.176,2.176,0,0,1-2.2,2.189,2.177,2.177,0,0,1-2.134-2.188c-.014-.86.005-1.72-.005-2.58a1.623,1.623,0,0,0-1.729-1.748q-14.567-.008-29.133,0a1.6,1.6,0,0,0-1.741,1.667q-.012,13.752,0,27.5A2.088,2.088,0,0,0-432.457,178.9Z",
    transform: "translate(436.856 -145.11)",
    fill: "#f18181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2141);
export default __webpack_public_path__ + "static/media/Group 2141.3871db7a95c3ac20745c745f84fb0422.svg";
export { ForwardRef as ReactComponent };